export const formatToLocalDateTime = (date: Date): string =>
  date.toLocaleString();
